import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'invoice.header',
    defaultMessage: 'Order Detail',
  },
  total: {
    id: 'invoice.total',
    defaultMessage: 'Total Payment',
  },
  price: {
    id: 'invoice.price',
    defaultMessage: 'Price',
  },
  admin: {
    id: 'invoice.admin',
    defaultMessage: 'Admin Fee',
  },
  title: {
    id: 'invoice.title',
    defaultMessage: 'Information Detail',
  },
  service: {
    id: 'invoice.service',
    defaultMessage: 'Service Name',
  },
  biller: {
    id: 'invoice.biller',
    defaultMessage: 'Provider Name',
  },
  cust_no: {
    id: 'invoice.cust_no',
    defaultMessage: 'Customer Number',
  },
  cust_name: {
    id: 'invoice.cust_name',
    defaultMessage: 'Customer Name',
  },
  number: {
    id: 'invoice.number',
    defaultMessage: 'Invoice Number',
  },
  help: {
    id: 'invoice.help',
    defaultMessage: 'Help Center',
  },
  created: {
    id: 'invoice.process.created',
    defaultMessage: 'Order Made',
  },
  process: {
    id: 'invoice.process.process',
    defaultMessage: 'Order Processed',
  },
  progress: {
    id: 'invoice.process.progress',
    defaultMessage: 'Waiting for Verification',
  },
  success: {
    id: 'invoice.process.success',
    defaultMessage: 'Order Successful',
  },
  failed: {
    id: 'invoice.process.failed',
    defaultMessage: 'Order Failed',
  },
  refunded: {
    id: 'invoice.process.refunded',
    defaultMessage: 'Order Refunded',
  },
  placeholder: {
    id: 'invoice.placeholder',
    defaultMessage: 'Please wait, your order detail is being prepared',
  },
});
